import { setStore, getStore } from "Pub/js/storageUtils";
import platform from "Pub/js/platform";
const { appIcons } = platform;
/**
 * 应用 icon 图标存储，供单据使用
 * @param {*} image_src 图标名
 * @param {*} appcode 应用编码
 */
const appIconSetFun = (appcode, image_src) => {
    let appIconsStore = getStore("APPICONSSTORE");
    let appIcon = appIcons && appIcons[image_src] ? image_src : "default";
    if (appIconsStore) {
        if (!appIconsStore[appcode]) {
            appIconsStore[appcode] = appIcon;
        }
    } else {
        appIconsStore = {};
        appIconsStore[appcode] = appIcon;
    }
    setStore("APPICONSSTORE", appIconsStore);
};
export default appIconSetFun;
